/** What a logo can be: the formats the logo slot's picker offers and the design engine can draw. */
export const LOGO_ACCEPT = 'image/svg+xml,image/png,image/jpeg';

/**
 * Why this file can't be a logo, or null when it can.
 *
 * Checked before uploading because the picker's `accept` is only a suggestion ("All files" is one
 * click away) and the upload endpoint now also stores PDFs: a logo.pdf would be saved as the logo,
 * show as a broken image, and silently leave every generated design without one.
 */
export function logoFileProblem(file: { name: string; type: string }): string | null {
  return LOGO_ACCEPT.split(',').includes(file.type) ? null : `${file.name} isn't an SVG, PNG or JPEG.`;
}
